import { expenseBalanceDelta, type Loan, type LoanBalance, type Overview } from './ledger'

export function nextUnpaidInstallment(loan:Loan,balance:LoanBalance){
  let paid=loan.principalCents-balance.principalOutstandingCents
  for(const installment of loan.installments??[]){
    if(paid>=installment.principalCents){paid-=installment.principalCents;continue}
    return {...installment,remainingCents:installment.principalCents-paid}
  }
  return null
}

export function personExpenses(data: Overview, personID: string) {
  return data.expenses.filter((expense) => {
    const payers = expense.payerAmounts ?? { [expense.paidById]: expense.amountCents }
    return (payers[personID] !== undefined || expense.participantIds.includes(personID)) && (payers[data.currentUser.id] !== undefined || expense.participantIds.includes(data.currentUser.id))
  }).sort((a,b) => new Date(b.occurredAt ?? b.createdAt).getTime()-new Date(a.occurredAt ?? a.createdAt).getTime() || a.id.localeCompare(b.id))
}

export function expenseHistory(data: Overview, personID: string, currency: string) {
  const events = [
    ...personExpenses(data, personID).filter(e=>e.currency===currency).map(e=>({id:e.id,date:e.occurredAt??e.createdAt,amount:expenseBalanceDelta(e,data.currentUser.id,personID)})),
    ...data.settlements.filter(s=>s.personId===personID && s.currency===currency).map(s=>({id:s.id,date:s.paidAt??s.createdAt,amount:s.direction==='received'?-s.amountCents:s.amountCents})),
    ...(data.expenseTransfers??[]).filter(t=>t.personId===personID && t.currency===currency).map(t=>({id:t.loanId,date:t.createdAt,amount:t.amountCents})),
  ].sort((a,b)=>new Date(a.date).getTime()-new Date(b.date).getTime()||a.id.localeCompare(b.id))
  const current=data.balances.find(b=>b.personId===personID && b.currency===currency)?.amountCents??0
  let running=current-events.reduce((sum,e)=>sum+e.amount,0)
  return events.map(event=>{running+=event.amount;return {date:event.date,value:running}})
}
